import { makeAutoObservable } from 'mobx';
class BpmnStroe {
    wofrkflowInfos = {
        taskFlowVOS: [],
        highLightedFlows: [],
        activeActivityIds: [],
    };
    clickedElement = null;
    constructor() {
        makeAutoObservable(this);
    }
    setTaskFlowVOS = (wofrkflowInfos) => {
        this.wofrkflowInfos = wofrkflowInfos;
    };
    setClickedElement = (el) => {
        this.clickedElement = el;
    };
}
export default new BpmnStroe();
